import { ReactNode, useCallback, useEffect } from 'react';
import Head from 'next/head';
import useStrapiOrderContext from 'lib/hooks/useStrapiOrderContext';
import { useCookies } from 'react-cookie';

const isProd = process.env.ENVIRONMENT_NAME === 'production';

const SafeTechConfig = ({ children }: { children: ReactNode }) => {
  const {
    orderParams: { mdc: mdc_code },
    kaptchaCookie,
    setKaptchaCookie,
  } = useStrapiOrderContext();
  const [cookies, setCookie] = useCookies([`KaptchaSessionID-${mdc_code}`]);

  const setKaptchaSessionCookie = useCallback(() => {
    const newKaptchaCookieValue = `${mdc_code}${Date.now()}`;
    setCookie(`KaptchaSessionID-${mdc_code}`, newKaptchaCookieValue);
    setKaptchaCookie?.(newKaptchaCookieValue);
  }, [mdc_code, setCookie, setKaptchaCookie]);

  useEffect(() => {
    if (!kaptchaCookie) {
      const kaptchaSessionID = cookies[`KaptchaSessionID-${mdc_code}`];
      if (!kaptchaSessionID) {
        setKaptchaSessionCookie();
      } else {
        setKaptchaCookie?.(kaptchaSessionID);
      }
    }
  }, [
    cookies,
    kaptchaCookie,
    mdc_code,
    setKaptchaCookie,
    setKaptchaSessionCookie,
  ]);

  const kaptchaSessionID =
    kaptchaCookie || cookies[`KaptchaSessionID-${mdc_code}`];
  const safeTechScriptSrc = isProd
    ? `https://ssl.kaptcha.com/collect/sdk?m=300699&s=${kaptchaSessionID}`
    : `https://tst.kaptcha.com/collect/sdk?m=300699&s=${kaptchaSessionID}`;

  if (!kaptchaCookie) return null;

  return (
    <>
      <Head>
        <script defer type="text/javascript" src={safeTechScriptSrc}></script>
      </Head>
      {children}
    </>
  );
};

export default SafeTechConfig;
